
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_people/components/role_editor/templates/role"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class='modal_content_section'>\n  <header class='modal_content_section_header'>\n    <h1 class='section_title'>\n      User Role\n    </h1>\n  </header>\n  <div class='role_dropdown_region'></div>\n</section>\n";
},"useData":true});
    }).call(this);
  